export default store => store.promo;
